@if (product$ | async; as product) {
  <div class="container product-spec-tab">
    @for (class of product?.classifications; track class) {
      <table [hidden]="filterClassifications(class)">
        <th>
          <h3>{{ class.name }}</h3>
        </th>
        @for (feature of class.features; track feature) {
          <tr>
            <td>{{ feature.name }}</td>
            <td>
              <ul>
                @for (featureValue of feature?.featureValues; track featureValue) {
                  <li>
                    {{ featureValue?.value }}
                    @if (feature.featureUnit?.symbol?.length > 0 && feature.featureUnit.unitType != '300') {
                      <span>
                        {{ feature.featureUnit.symbol }}
                      </span>
                    }
                  </li>
                }
              </ul>
            </td>
          </tr>
        }
      </table>
    }
  </div>
}
